import http from '@/utils/http';
import { fetchReportTencentQCouldMassage } from '@intelligence/services/cos';
import { fetchUserInformation as fetchUserInformationOriginal } from '@user-center/services/common';
import {
  fetchReports as fetchReportsOriginal,
  addReport as addReportOriginal,
  updateReport as updateReportOriginal,
} from '@user-center/services/report';
import { showErrorMessagetip } from '@home/components/ErrorMessageTip/ErrorMessageTip';
import { formatReport, formatReportReq } from '../utils';

interface IHTMLZipReportUploadData {
  htmlPath: string;
  htmlFiles: string[];
  hasThumbnail: boolean;
}

interface IAddReportAuthPathsParams {
  report_id: string;
  paths: string[];
}

// 报告上传错误信息配置
const ADD_UPDATE_REPORT_ERROR_MSG_MAP: Record<number, string> = {
  // 上传报告的作者不是当前登录用户
  100000001: 'dbu_report_add_update_error_tips1',
  // 没有IIC权限
  100000002: '没有IIC权限',
  // 没有GRC权限
  100000003: '没有GRC权限',
  // 没有个人中心报告管理员权限
  100000004: '没有个人中心报告管理员权限',
  // 管理员操作必须提供目标用户
  100000005: '管理员操作必须提供目标用户',
  // 目标用户不存在或已离职
  100000006: '目标用户不存在或已离职',
  // 管理员模式只能操作已发布报告
  100000008: '管理员模式只能操作已发布报告',
};
export const handleAddUpdateReportError = (formatMessage: any, error: any) => {
  const { code, msg } = error || {};

  const msgNew = formatMessage({ id: ADD_UPDATE_REPORT_ERROR_MSG_MAP[code] }) || msg || 'unknown error';

  showErrorMessagetip({
    type: 'error',
    isClose: true,
    duration: 5000,
    errorCode: code,
    content: msgNew,
  });
};

export const fetchReportGZTencentQCouldMassage = async () => {
  const res = await fetchReportTencentQCouldMassage({ cos_config: 'guangzhou' });
  return res?.data;
};

export const fetchReportSGTencentQCouldMassage = async () => {
  const res = await fetchReportTencentQCouldMassage({ cos_config: 'singapore' });
  return res?.data;
};

/**
 * 上传市场报告时，拉取登录用户信息，默认用 gc_zhenghanliang 作为报告作者信息（因为市场报告没有作者，后端接口中报告作者字段没必填字段，所以用 gc_zhenghanliang 作为兜底的作者信息）
 * @param params 参数对象
 * @param params.username 用户名
 * @return 用户信息
 */
export const fetchUserInformation = async (params: { username: string }) => {
  try {
    const res = await fetchUserInformationOriginal(params);
    const resData = res?.data;
    const userFullName = resData?.full_name || '';
    const userName = resData?.user_name || '';

    if (userFullName && userName) {
      return res;
    }

    return {
      ...res,
      data: {
        ...resData,
        full_name: 'gc_zhenghanliang(郑汉良)',
        user_name: '郑汉良',
        user_name_en: 'gc_zhenghanliang',
        department_name: '技术中台',
      },
    };
  } catch (error) {
    console.error(error);
  }
};

export const uploadHTMLZipReport = (params: { file: File; key: string }): IBaseResponse<IHTMLZipReportUploadData> => {
  const { key, file } = params;
  const data = new FormData();
  data.append('key', key);
  data.append('file', file);

  return http({
    url: '/api/auth-server/upload',
    method: 'post',
    data,
    rawData: true,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }) as any;
};

export const addReportAuthPaths = (params: IAddReportAuthPathsParams): IBaseResponse => {
  return http({
    url: '/api/v1/intelligence_pc/user/report/auth/path/add',
    method: 'post',
    data: params,
    rawData: true,
  }) as any;
};

export const fetchReports = async (
  ...params: Parameters<typeof fetchReportsOriginal>
): IBaseResponse<IPaginationData<IReport>> => {
  const res = await fetchReportsOriginal(...params);
  const resData = res?.data;
  const reports = resData?.list?.map(formatReport) || [];

  return {
    ...res,
    data: {
      ...resData,
      list: reports,
    },
  };
};

export const addReport = (params: IReport, mutationParams: IReportMutationParams) => {
  return addReportOriginal({ ...formatReportReq(params), ...mutationParams });
};

export const updateReport = (params: IReport, mutationParams: IReportMutationParams) => {
  return updateReportOriginal({ ...formatReportReq(params), ...mutationParams });
};
